module.exports = __webpack_public_path__ + "static/media/decreto kwong 2 50 (2).837eabdd.jpg";